<template>
  <div>
    <h2>{{ $t('views.vouchers.detail.title') }}</h2>

    <entity-detail-table
      :key="tenants.length"
      :entityKey="eParent.key"
      :entityId="eParent.id"

      @control:input="onInput"
      @control:change="onChange"
      @entity:save="onSave"
    />
  </div>
</template>

<script>
import http from '@/$plugins/http';
import MixinEntityBase from '@/components/mixins/EntityBase';
import EntityDetailTable from '@/components/entity/DetailTable';

export default {
  name: 'Vouchers.Detail',
  mixins: [MixinEntityBase],
  components: {
    EntityDetailTable
  },
  computed: {
    tenants () {
      return this.$store.getters['tenants/getUnwrapped'] || [];
    }
  },
  methods: {
    onInput (controlValue) {
    },
    onChange (controlValue) {
    },
    async onSave (entity) {
      var code = entity.Code || entity.code;
      var tenant = entity.Tenant || entity.tenant;
      var entityId = entity.id;

      if (code && tenant) {
        try {
          var response = await http({
            method: 'get',
            url: '/order/api/voucher/code-exists/' + encodeURIComponent(code) + '/' + encodeURIComponent(tenant) + '?excludeId=' + entityId
          });
          if (response.data && response.data.result === true) {
            this.$bvToast.toast(this.$t('views.vouchers.errors.duplicatecode'), {
              title: this.$t('common.error'),
              variant: 'danger',
              solid: true
            });
            return;
          }
        } catch (e) {
          // If check fails, proceed with update
        }
      }

      this.$store.dispatch(`${this.eParent.key}/updateEntity`, entity);
    }
  },
  created () {
    this.$store.dispatch('tenants/getAll');
  }
};
</script>

<style lang="scss"></style>
